/**
 * DataExplorerPanel — AG Grid Enterprise + Integrated Charts.
 *
 * The JMP equivalent: a single docking panel where engineers see their run
 * table data, right-click to chart any columns, cross-filter between views,
 * and every chart carries provenance.
 */

import { Box } from "@radix-ui/themes";
import { DataExplorer } from "../data-explorer/DataExplorer";

interface Props {
  projectId: string;
  isVisible?: boolean;
}

export default function DataExplorerPanel({ projectId, isVisible }: Props) {
  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <DataExplorer projectId={projectId} isVisible={isVisible} />
    </Box>
  );
}
